import { render, staticRenderFns } from "./PerformanceManage.vue?vue&type=template&id=6ebc0656&scoped=true&"
import script from "./PerformanceManage.vue?vue&type=script&lang=js&"
export * from "./PerformanceManage.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceManage.vue?vue&type=style&index=0&id=6ebc0656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc0656",
  null
  
)

export default component.exports